import * as React from 'react'
import { base64ToBlob, safeFileName } from './pdf_utils'

/**
 * Preview / Print / Download for a base64 PDF of any size.
 * props: base64 (string), fileName (string), height (css, optional)
 */
export default class PdfViewer extends React.Component {
  constructor (props) {
    super(props)
    this.state = { url: null, error: null, size: 0 }
    this.printFrame = null
    this.print = this.print.bind(this)
    this.download = this.download.bind(this)
    this.openTab = this.openTab.bind(this)
  }

  componentDidMount () {
    this.build()
  }

  componentDidUpdate (prev) {
    if (prev.base64 !== this.props.base64) this.build()
  }

  componentWillUnmount () {
    this.release()
  }

  release () {
    if (this.state.url) URL.revokeObjectURL(this.state.url)
    this.removePrintFrame()
  }

  build () {
    this.release()
    try {
      if (!this.props.base64) throw new Error('This document has no content.')
      const blob = base64ToBlob(this.props.base64)
      this.setState({ url: URL.createObjectURL(blob), error: null, size: blob.size })
    } catch (e) {
      console.error(e)
      this.setState({ url: null, error: 'This document could not be read (' + e.message + ').' })
    }
  }

  removePrintFrame () {
    if (this.printFrame && this.printFrame.parentNode) this.printFrame.parentNode.removeChild(this.printFrame)
    this.printFrame = null
  }

  print () {
    const { url } = this.state
    if (!url) return
    this.removePrintFrame()
    const frame = document.createElement('iframe')
    frame.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;'
    frame.src = url
    frame.onload = () => {
      try {
        frame.contentWindow.focus()
        frame.contentWindow.print()
      } catch (e) {
        // Some browsers block printing a PDF from a hidden frame: fall back to the browser's own viewer.
        window.open(url, '_blank')
      }
    }
    document.body.appendChild(frame)
    this.printFrame = frame
  }

  download () {
    const { url } = this.state
    if (!url) return
    const a = document.createElement('a')
    a.href = url
    a.download = safeFileName(this.props.fileName)
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  openTab () {
    if (this.state.url) window.open(this.state.url, '_blank')
  }

  render () {
    const { url, error, size } = this.state
    const btn = { marginRight: 6, opacity: url ? 1 : 0.5, cursor: url ? 'pointer' : 'default' }
    return (
      <div style={{ display: 'flex', flexDirection: 'column', height: this.props.height || 'calc(93vh - 120px)', width: '100%' }}>
        <div style={{ padding: '6px 0', borderBottom: '0.5px solid #efefef', display: 'flex', alignItems: 'center', background: '#fff' }}>
          <button className={'submit'} style={btn} disabled={!url} onClick={this.print}><span className={'fa fa-print'} /> Print</button>
          <button style={btn} disabled={!url} onClick={this.download}><span className={'fa fa-download'} /> Download</button>
          <button className={'default'} style={btn} disabled={!url} onClick={this.openTab}><span className={'fa fa-external-link'} /> Open in new tab</button>
          {size > 0 ? <span style={{ marginLeft: 'auto', color: '#888', fontSize: 12 }}>{(size / 1048576).toFixed(2)} MB</span> : null}
        </div>
        <div style={{ flex: 1, minHeight: 0, border: '0.5px solid #efefef', borderTop: 'none' }}>
          {error ? <div style={{ padding: 16, color: '#DF4A36' }}>{error}</div>
            : url ? <embed type={'application/pdf'} src={url} style={{ height: '100%', width: '100%' }} />
              : <div style={{ padding: 16 }}>Preparing document...</div>}
        </div>
      </div>
    )
  }
}
